import { useField } from 'formik'
import PropTypes from 'prop-types'
import Form from '~/components/shared/Form'
import UserMedia from '~/components/shared/UserMedia'
import { getCurrentUser } from '~/utils/auth'
import withLocale from '~/hocs/locale'

const AsAnonymousInput = ({ label, ...props }) => {
  const [_, meta] = useField(props)

  const author = getCurrentUser()

  return (
    <div className="d-flex justify-content-between w-100">
      {!!author && <UserMedia value={{ author }} asAnonymous={meta.value} />}
      <Form.Check
        className="pt-3"
        type="switch"
        options={[
          {
            label,
            name: 'asAnonymous',
          },
        ]}
      />
    </div>
  )
}

AsAnonymousInput.propTypes = {
  label: PropTypes.string.isRequired
}

export default withLocale('common', 'asAnonymousInput')(AsAnonymousInput)
